export let ribbonCustomize = "p9IGdc";
export default {ribbonCustomize};